import React from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router";
import Header from "./Header";
import DataTabs from "./DataTabs";
import { useSelector } from "react-redux";
import { MeterCommandsSelector } from "store/meter-management/meters/selectors";
import MetaData from "components/VerticalLayout/MetaData";

const EditSpareParts = () => {
  const { id } = useParams();
  const { activeSparePart } = useSelector(MeterCommandsSelector);

  return (
    <div className="page-content">
      <Container fluid>
        <MetaData pageTitle={activeSparePart.name} />

        <Header id={id} />
        <DataTabs id={id} />
      </Container>
    </div>
  );
};

export default EditSpareParts;
